import { API } from "utils";

export const getAgentQueues = async () => {
    try {
        const response = await API().get("api/queues/get-entry-queues");
        return { success: true, payload: response.data };
    } catch (e) {
        return { success: false, payload: [], error: e };
    }
};

export const createAgentQueue = async (data) => {
    try {
        const response = await API().post("api/queues/create-entry-queue", data);
        return { success: true, payload: response.data };
    } catch (e) {
        return { success: false, payload: null, error: e };
    }
};

export const updateAgentQueue = async (id, data) => {
    try {
        const response = await API().put(`api/queues/update-entry-queue/${id}`, data);
        return { success: true, payload: response.data };
    } catch (e) {
        return { success: false, payload: null, error: e };
    }
};

export const deleteAgentQueue = async (id) => {
    try {
        await API().delete(`api/queues/delete-entry-queue/${id}`);
        return { success: true };
    } catch (e) {
        return { success: false, error: e };
    }
};
